// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################

import {utils} from "@mc/mc-legacy";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch, generateUrl} = utils;

import * as UpdateMethods from "./UpdateMethods";

/**
 * Created by Marbes Consulting jaroslav.hudec@marbes.cz / 24.08.2018. Generated from cz.marbes.cgo.controller.PolozkaController.
 */
export default class PolozkaApi {
    /**
     * 
     *
     * @param cenikId 
     * @param cenikPolozkaId 
     * @return cz.marbes.cgo.controller.vo.CenikPolozkaVO
     */
    static getCenikPolozka(cenikId, cenikPolozkaId) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/polozka/${cenikPolozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param polozkaParovaniVO 
     * @return cz.marbes.cgo.controller.vo.PolozkaParovaniVO
     */
    static createPolozkaParovani(polozkaParovaniVO) {
        const uri = serverContextPath + `/api/cgo/polozka/polozkyparovani`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, polozkaParovaniVO, headers));
    }

    /**
     * 
     *
     * @param polozkaVO 
     * @return cz.marbes.cgo.controller.vo.PolozkaVO
     */
    static createPolozka(polozkaVO) {
        const uri = serverContextPath + `/api/cgo/polozka/polozky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, polozkaVO, headers));
    }

    /**
     * 
     *
     * @param platneKDatu 
     * @param spolecnostId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.CenikVO>
     */
    static getCeniky(platneKDatu, spolecnostId) {
        const uri = serverContextPath + `/api/cgo/polozka/ceniky`;
        const headers = undefined;
        const params = { platneKDatu, spolecnostId };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param polozkaParovaniId 
     * @return cz.marbes.cgo.controller.vo.PolozkaParovaniVO
     */
    static getPolozkaParovani(polozkaParovaniId) {
        const uri = serverContextPath + `/api/cgo/polozka/polozkaparovani/${polozkaParovaniId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param cenikId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.CenikPolozkaVO>
     */
    static getCenikPolozky(cenikId) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/polozky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param cenikId 
     * @param cenikPolozkaVO 
     * @return cz.marbes.cgo.controller.vo.CenikPolozkaVO
     */
    static createCenikPolozka(cenikId, cenikPolozkaVO) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/polozky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, cenikPolozkaVO, headers));
    }

    /**
     * 
     *
     * @param polozkaId 
     * @return cz.marbes.cgo.controller.vo.PolozkaVO
     */
    static getPolozka(polozkaId) {
        const uri = serverContextPath + `/api/cgo/polozka/polozka/${polozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @return java.util.List<cz.marbes.cgo.controller.vo.PolozkaParovaniVO>
     */
    static getPolozkyParovani() {
        const uri = serverContextPath + `/api/cgo/polozka/polozkyparovani`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param cenikId 
     * @return java.util.List<cz.marbes.cgo.controller.vo.SpolecnostVO>
     */
    static findSpolecnostiCeniku(cenikId) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/spolecnosti`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param cenikId 
     * @return cz.marbes.cgo.controller.vo.CenikVO
     */
    static getCenikById(cenikId) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * Smazání položky na existujícím ceníku @param cenikId id ceníku @param cenikPolozkaId id položky ceníku ke smazání @return aktualizovaná objednávka
     *
     * @param cenikId 
     * @param cenikPolozkaId 
     */
    static deleteCenikPolozka(cenikId, cenikPolozkaId) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/polozka/${cenikPolozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param polozkaParovaniVO 
     * @param polozkaParovaniId 
     * @return cz.marbes.cgo.controller.vo.PolozkaParovaniVO
     */
    static updatePolozkaParovani(polozkaParovaniVO, polozkaParovaniId) {
        const uri = serverContextPath + `/api/cgo/polozka/polozkyparovani/${polozkaParovaniId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, polozkaParovaniVO, headers));
    }

    /**
     * 
     *
     * @param cenikVO 
     * @param cenikId 
     * @return cz.marbes.cgo.controller.vo.CenikVO
     */
    static updateCenik(cenikVO, cenikId) {
        const uri = serverContextPath + `/api/cgo/polozka/ceniky/${cenikId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, cenikVO, headers));
    }

    /**
     * 
     *
     * @param cenikVO 
     * @return cz.marbes.cgo.controller.vo.CenikVO
     */
    static createCenik(cenikVO) {
        const uri = serverContextPath + `/api/cgo/polozka/ceniky`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.post(uri, params, cenikVO, headers));
    }

    /**
     * Smazání celého ceníku @param cenikId id ceníku
     *
     * @param cenikId 
     */
    static deleteCenik(cenikId) {
        const uri = serverContextPath + `/api/cgo/polozka/ceniky/${cenikId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.delete(uri, params));
    }

    /**
     * 
     *
     * @param cenikId 
     * @param cenikPolozkaId 
     * @param cenikPolozkaVO 
     * @return cz.marbes.cgo.controller.vo.CenikPolozkaVO
     */
    static updateCenikPolozka(cenikId, cenikPolozkaId, cenikPolozkaVO) {
        const uri = serverContextPath + `/api/cgo/polozka/cenik/${cenikId}/polozky/${cenikPolozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, cenikPolozkaVO, headers));
    }

    /**
     * 
     *
     * @param findtext 
     * @param neaktivni 
     * @return java.util.List<cz.marbes.cgo.controller.vo.PolozkaVO>
     */
    static getPolozky(findtext, neaktivni) {
        const uri = serverContextPath + `/api/cgo/polozka/polozky`;
        const headers = undefined;
        const params = { findtext, neaktivni };
         
        return ErrorApi.responseResolver(JsonFetch.get(uri, params, headers));
    }

    /**
     * 
     *
     * @param polozkaVO 
     * @param polozkaId 
     * @return cz.marbes.cgo.controller.vo.PolozkaVO
     */
    static updatePolozka(polozkaVO, polozkaId) {
        const uri = serverContextPath + `/api/cgo/polozka/polozky/${polozkaId}`;
        const headers = undefined;
        const params = {  };
         
        return ErrorApi.responseResolver(JsonFetch.put(uri, params, polozkaVO, headers));
    }

}
